<template>
  <div style="   font-size: 16px;">
    <div class="h1">
      <div class="w">
        <div class="li-1">
          <img src="../../assets/img/pagess/gdd112/logo.png" alt="" />
          <p>更精确 /更好用/更实战</p>
        </div>
        <div class="li-2">
          <img src="../../assets/img/pagess/gdd112/h1-1.png" alt="" />
        </div>
        <div class="li-3">
          <div class="left">
            <img src="../../assets/img/pagess/gdd112/h1-2.png" alt="" />
          </div>
          <div class="r">
            <div class="lis1">
              <img src="../../assets/img/pagess/gdd112/h1-3.png" alt="" />
              <p>新股民</p>
            </div>
            <p class="text">选时、选股、交易，一站式解决选股难题！</p>
            <div class="lis1">
              <img src="../../assets/img/pagess/gdd112/h1-3.png" alt="" />
              <p>老股民</p>
            </div>
            <p class="text">
              <span style="color: red">3</span> 分钟选股、<span
                style="color: red"
                >2</span
              >
              分钟操作、炒股很轻松！
            </p>
            <div class="lis2">
              <img
                class="btn"
                @click="to_xaizai()"
                src="../../assets/img/pagess/gdd112/btn1.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="ss">
        <img src="../../assets/img/pagess/gdd112/qqqqq.png" alt="" />
      </div>
    </div>
    <div class="h2" ref="obtain">
      <div class="w">
        <div class="li-1">
          <img src="../../assets/img/pagess/gdd112/h2-1.png" alt="" />
        </div>
        <div class="li-2">
          <div class="lis">
            <div class="text1" style="padding-top: 30px">股市趋势不同</div>
            <div class="text1">选择也会不同</div>
            <div class="text2" style="margin-top: 22px; margin-bottom: 5px">
              股市趋势较好的时候，建议选择板块
            </div>
            <div class="text2">类个股；趋势不好的时候，不要跟风</div>
          </div>
          <div class="lis">
            <div class="text1" style="padding-top: 30px">恐慌盘出来</div>
            <div class="text1">保持平稳心态</div>
            <div class="text2" style="margin-top: 22px; margin-bottom: 5px">
              涨幅居前的股票总有在明在暗
            </div>
            <div class="text2">的时候，交易时要保持平稳心态</div>
          </div>
          <div class="lis">
            <div class="text1" style="padding-top: 30px">理性投资</div>
            <div class="text1">切勿跟风买卖</div>
            <div class="text2" style="margin-top: 22px; margin-bottom: 5px">
              越跌越买等言论不可信，多进行
            </div>
            <div class="text2">风险评估，做到及时止损</div>
          </div>
        </div>
      </div>
      <div class="ss">
        <img src="../../assets/img/pagess/gdd112/qqqqq.png" alt="" />
      </div>
    </div>
    <div class="h3">
      <div class="w">
        <div class="li-1">
          <img src="../../assets/img/pagess/gdd112/h3-1.png" alt="" />
        </div>
        <div class="li-2">
          <div class="l">
            <div class="lis1">
              <img src="../../assets/img/pagess/gdd112/h3-2.png" alt="" />
            </div>
            <div class="lis2">
              <div>
                <span class="text">大盘决策：</span>
                一键知指数趋势，辨牛熊
              </div>
            </div>
            <div class="lis3">
              趋势方向、仓位配置、资金进出、风格变化，四重维度 研判大盘动向！
            </div>
          </div>
          <div class="r">
            <img src="../../assets/img/pagess/gdd112/h3-3.png" alt="" />
          </div>
        </div>
      </div>
      <div class="ss">
        <img src="../../assets/img/pagess/gdd112/qqqqq.png" alt="" />
      </div>
    </div>
    <div class="h4">
      <div class="w">
        <div class="r">
          <img src="../../assets/img/pagess/gdd112/h4-1.png" alt="" />
        </div>
        <div class="l">
          <div class="lis1">
            <img src="../../assets/img/pagess/gdd112/h4-2.png" alt="" />
          </div>
          <div class="lis2">
            <div>
              <span class="text">龙头雷达：</span>
              实现智能盯盘数据可视化
            </div>
          </div>
          <div class="lis3">
            秒速捕获异动板块，涵盖板块热度与涨停力度，一眼看
            出热点扩散效应与炒作持续性
          </div>
        </div>
      </div>
      <div class="ss">
        <img src="../../assets/img/pagess/gdd112/qqqqq.png" alt="" />
      </div>
    </div>
    <div class="h5">
      <div class="w">
        <div class="l">
          <div class="lis1">
            <img src="../../assets/img/pagess/gdd112/h5-2.png" alt="" />
          </div>
          <div class="lis2">
            <div>
              <span class="text">板块狙击：</span>
              多种选股思路，总有一个适合你
            </div>
          </div>
          <div class="lis3">
            一键选股：多种选股思路，龙头启动、龙头主升、龙头二
            波、龙头基因、趋势龙头···总有一个适合你！
          </div>
        </div>
        <div class="r">
          <img src="../../assets/img/pagess/gdd112/h5-1.png" alt="" />
        </div>
      </div>
      <div class="ss">
        <img src="../../assets/img/pagess/gdd112/qqqqq.png" alt="" />
      </div>
    </div>
    <div class="h6">
      <div class="w">
        <div class="r">
          <img src="../../assets/img/pagess/gdd112/h6-2.png" alt="" />
        </div>
        <div class="l">
          <div class="lis1">
            <img src="../../assets/img/pagess/gdd112/h6-1.png" alt="" />
          </div>
          <div class="lis2">
            <div>
              <span class="text">聚焦资金：</span>
              帮你轻松了解主力底牌
            </div>
          </div>
          <div class="lis3">
            9大资金模型、14家游资席位，通过机构和游资的动向
            优化出强势板块共振，龙头诞生在热门板块中
          </div>
        </div>
      </div>
      <div class="ss">
        <img src="../../assets/img/pagess/gdd112/qqqqq.png" alt="" />
      </div>
    </div>
    <div class="h7">
      <div class="w">
        <div class="l">
          <div class="lis1">
            <img src="../../assets/img/pagess/gdd112/h7-1.png" alt="" />
          </div>
          <div class="lis2">
            <div>
              <span class="text">互动交流+实战教学</span>
              <div>
                <span class="text">构建你的投资体系</span>
              </div>
            </div>
          </div>
        </div>
        <div class="r">
          <img src="../../assets/img/pagess/gdd112/h7-2.png" alt="" />
        </div>
      </div>
      <div class="ss">
        <img src="../../assets/img/pagess/gdd112/qqqqq.png" alt="" />
      </div>
    </div>
    <div class="h8">
      <div class="w">
        <div class="li-1">更多辅助功能让投资变得更简单</div>
        <div class="li-2">
          <div class="l">
            <img src="../../assets/img/pagess/gdd112/h8-1.png" alt="" />
          </div>
          <div class="r">
            <div class="lis1">
              <img src="../../assets/img/pagess/gdd112/h8-3.png" alt="" />
              <span>智能诊股</span>
            </div>
            <div class="lis2">交易机会、资金流向、技术指标、市场热度</div>
            <div class="lis2">股票情报，一测便知；更能深挖市场认可度</div>
            <div class="lis2">重要经济数据及上市公司信息披露</div>
          </div>
        </div>
        <div class="li-3">
          <div class="r">
            <div class="lis1">
              <img src="../../assets/img/pagess/gdd112/h8-6.png" alt="" />
              <span>数据统计</span>
            </div>
            <div class="lis2">盯盘是实盘操作中很关键的步骤，通过数据统</div>
            <div class="lis2">计可以观察资金对决间的接盘与压盘力度，更</div>
            <div class="lis2">能清晰反映出什么类型的资金是市场领头羊</div>
          </div>
          <div class="l">
            <img src="../../assets/img/pagess/gdd112/h8-5.png" alt="" />
          </div>
        </div>
      </div>
      <div class="ss">
        <img src="../../assets/img/pagess/gdd112/qqqqq.png" alt="" />
      </div>
    </div>
    <div class="h9">
      <div class="w">
        <div class="li-1">股多多选股决策系统适合哪些人呢？</div>
        <div class="li-2">
          <div class="lis1">
            <div class="liss1">
              <img src="../../assets/img/pagess/gdd112/h9-1.png" alt="" />
            </div>
            <div class="liss2"><span>单打独斗</span>的散户</div>
            <div class="liss3">只想做业余投资</div>
          </div>
          <div class="lis2">
            <div class="liss1">
              <img src="../../assets/img/pagess/gdd112/h9-2.png" alt="" />
            </div>
            <div class="liss2"><span>经常踩坑</span></div>
            <div class="liss3">不知道如何选股</div>
          </div>
          <div class="lis3">
            <div class="liss1">
              <img src="../../assets/img/pagess/gdd112/h9-3.png" alt="" />
            </div>
            <div class="liss2"><span>短线操作</span>投资者</div>
            <div class="liss3">总是找不到机会</div>
          </div>
        </div>
      </div>
    </div>
    <div class="h10">
      <div class="w">
        <div class="li-1">
          <img src="../../assets/img/pagess/gdd112/h10-1.png" alt="" />
        </div>
        <div class="li-2">
          <img src="../../assets/img/pagess/gdd112/h10-2.png" alt="" />
        </div>
      </div>
    </div>
    <div class="bottomss">
      <div class="boxx"></div>
      <p>————&nbsp;投资有风险入市需谨慎&nbsp;————</p>
      <p>
        从事证券投资或期货交易，请通过合法证券期货经营机构进行&nbsp;&nbsp;&nbsp;
        合法机构名单可到中国证监会网站 (<a href="http://www.csrc.gov.cn/"
          >www.csrc.gov.cn</a
        >)查询
      </p>
      <p>
        北京天相财富管理顾问有限公司 &nbsp;&nbsp;&nbsp;
        <a href="https://beian.miit.gov.cn/">京ICP备16068579号-1</a
        >&nbsp;&nbsp;&nbsp; 执证编号：91110102MA001GJE1N
      </p>
      <p>天相股多多软件版本号：v1.3.1.1288 更新时间：2022年12月</p>
      <p style="text-decoration: underline; cursor: pointer" class="qwer">
        <!-- 联系电话:010-********&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
        <span @click="open_yinsi()" style="margin-right: 10px"
          >隐私保护政策</span
        >
        <span @click="open_fuwuxieyi()">软件服务协议</span>
      </p>
      <p>开发者名称:北京天相财富管理顾问有限公司</p>
    </div>
    <div class="box"></div>
    <div class="bar" v-if="res">
      <div class="w">
        <img
          class="btn"
          @click="to_xaizai()"
          src="../../assets/img/pagess/gdd112/btn1.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      res: false
    };
  },
  mounted() {
    this.clientIp();
    // 滚动条的获取
    window.addEventListener("scroll", this.handleScrollx, true);
  },
  methods: {
    // open_yinsi() {
    //   window.open("https://ins.juniubang.com/images/隐私政策（河北）4.7.pdf");
    // },
    // open_fuwuxieyi() {
    //   window.open(
    //     "https://ins.juniubang.com/images/%E5%BA%94%E7%94%A8%E6%9D%83%E9%99%904.7(%E6%B2%B3%E5%8C%97).pdf"
    //   );
    // },
    open_yinsi() {
      window.open("https://cdn.juniubang.com/apk/隐私政策4.7.pdf");
    },
    open_fuwuxieyi() {
      window.open("https://cdn.juniubang.com/apk/许可使用协议4.7.pdf");
    },
    changebar(index) {
      this.active = index;
    },
    to_xaizai() {
      this.post_leilei_data();
      // window.open("https://cdn.juniubang.com/apk/GDD2002.exe");

      this.message = "";
    },
    // 给磊磊传页面数据
    post_leilei_data() {
      this.$http
        .post("/to_exe", {
          qhclickid: this.$route.query.qhclickid,
          url: window.location.href,
          code: this.$route.query.code,
          type: "360"
        })
        .then(res => {  window.open(res.data.message);});
    },

    handleScrollx() {
      if (this.$refs.obtain.getBoundingClientRect().top < 1000) {
        this.res = true;
      } else {
        this.res = false;
      }
    },
    clientIp() {
      this.$http.post("/client_ip", { url: window.location.href }).then(res => {
        window.localStorage.setItem("_number", res.data);
      });
    }
    // post_data() {
    //   this.$http
    //     .post("/to_api", {
    //       qhclickid: this.$route.query.qhclickid,
    //       trans_id: this.$route.query.qhclickid,
    //     })
    //     .then((res) => {
    //
    //     });
    // },
  }
};
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  height: 220px;
  background-color: #4a4a4a;
}
.bar {
  width: 100%;
  height: 208px;
  background: url(../../assets/img/pagess/gdd112/bar.png) no-repeat center;
  position: fixed;
  bottom: 0;
  .w {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-top: 25px;
  }
}

.bottomss {
  width: 100%;

  height: 150px;
  background-color: #4a4a4a;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  .boxx {
    width: 100%;
    height: 30px;
  }
  .qwer span:hover {
    color: #fff;
  }
  a {
    font-size: 12px;
    color: #fff;
  }
  p {
    margin: 0;
    font-size: 12px;
    color: #6e7a9e;
  }
}
p {
  margin: 0;
  padding: 0;
}
.h1 {
  width: 100%;
  height: 923px;
  background: url(../../assets/img/pagess/gdd112/h1.jpg) no-repeat center;

  .ss {
    width: 20px;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      top: -25px;
    }
  }
  .w {
    width: 1206px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    .li-1 {
      height: 80px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      p {
        font-size: 17px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3e3e3e;
        line-height: 21px;
      }
    }
    .li-2 {
      margin-bottom: 46px;
    }
    .li-3 {
      width: 100%;
      display: flex;
      .left {
        margin-right: 46px;
      }
      .r {
        .lis1 {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          p {
            margin: 0;
            margin-left: 14px;
            font-size: 37px;
            font-weight: bold;
            color: #a60100;
          }
        }
        .text {
          margin: 15px 0;
          font-size: 26px;
          color: #000;
        }
        .lis2 {
          margin-top: 100px;
        }
      }
    }
  }
}
.h2 {
  width: 100%;
  height: 519px;
  background: url(../../assets/img/pagess/gdd112/h2.png) no-repeat center;
  .ss {
    width: 20px;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      top: -25px;
    }
  }
  .w {
    width: 1202px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      margin-top: 58px;
      margin-bottom: 64px;
    }
    .li-2 {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .lis {
        width: 374px;
        height: 232px;
        background: url(../../assets/img/pagess/gdd112/h2-2.png) no-repeat
          center;
        display: flex;
        flex-direction: column;
        align-items: center;
        .text1 {
          font-size: 35px;
          font-weight: bold;
          color: #a70100;
        }
        .text2 {
          font-size: 18px;

          font-weight: 400;
          color: #737272;
        }
      }
    }
  }
}
.h3 {
  width: 100%;
  height: 775px;
  background: url(../../assets/img/pagess/gdd112/h3.png) no-repeat center;
  .ss {
    width: 20px;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      top: -20px;
    }
  }
  .w {
    width: 1202px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 72px;
      margin-bottom: 55px;
    }
    .li-2 {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .l {
        height: 100%;
        .lis1 {
          padding-top: 85px;
          margin-bottom: 55px;
        }
        .lis2 {
          font-size: 26px;
          color: #f34950;
          font-weight: 600;
          .text {
            font-size: 33px;
            font-weight: bold;
            color: #000000;
          }
        }
        .lis3 {
          margin-top: 47px;
          width: 480px;
          height: 49px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #6a6a6a;
          line-height: 29px;
        }
      }
    }
  }
}
.h4 {
  width: 100%;
  height: 716px;
  background: url(../../assets/img/pagess/gdd112/h4.png) no-repeat center;
  .ss {
    width: 20px;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      top: -25px;
    }
  }
  .w {
    width: 1202px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-items: center;
    .l {
      height: 100%;
      margin-left: 53px;
      .lis1 {
        padding-top: 200px;
        margin-bottom: 55px;
      }
      .lis2 {
        font-size: 26px;
        color: #f34950;
        font-weight: 600;
        .text {
          font-size: 33px;
          font-weight: bold;
          color: #000000;
        }
      }
      .lis3 {
        margin-top: 40px;
        width: 480px;
        height: 49px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #6a6a6a;
        line-height: 29px;
      }
    }
  }
}
.h5 {
  width: 100%;
  height: 644px;
  background: url(../../assets/img/pagess/gdd112/h5.png) no-repeat center;
  .ss {
    width: 20px;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      top: -25px;
    }
  }
  .w {
    width: 1202px;
    margin: 0 auto;
    display: flex;

    justify-content: space-between;
    padding-top: 67px;
    .l {
      height: 100%;
      .lis1 {
        margin-bottom: 55px;
        padding-top: 85px;
      }
      .lis2 {
        font-size: 26px;
        color: #f34950;
        font-weight: 600;
        .text {
          font-size: 33px;
          font-weight: bold;
          color: #000000;
        }
      }
      .lis3 {
        margin-top: 47px;
        width: 480px;
        height: 49px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #6a6a6a;
        line-height: 29px;
      }
    }
  }
}
.h6 {
  width: 100%;
  height: 716px;
  background: url(../../assets/img/pagess/gdd112/h6.png) no-repeat center;
  .ss {
    width: 20px;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      top: -25px;
    }
  }
  .w {
    width: 1202px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-items: center;
    .l {
      height: 100%;
      margin-left: 53px;
      .lis1 {
        padding-top: 200px;
        margin-bottom: 55px;
      }
      .lis2 {
        font-size: 26px;
        color: #f34950;
        font-weight: 600;
        .text {
          font-size: 33px;
          font-weight: bold;
          color: #000000;
        }
      }
      .lis3 {
        margin-top: 40px;
        width: 480px;
        height: 49px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #6a6a6a;
        line-height: 29px;
      }
    }
  }
}
.h7 {
  width: 100%;
  height: 620px;
  background: url(../../assets/img/pagess/gdd112/h5.png) no-repeat center;
  .ss {
    width: 20px;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      top: -25px;
    }
  }
  .w {
    width: 1202px;
    margin: 0 auto;
    display: flex;

    justify-content: space-between;
    padding-top: 67px;
    .l {
      height: 100%;
      .lis1 {
        margin-bottom: 55px;
        padding-top: 85px;
      }
      .lis2 {
        font-size: 26px;
        color: #f34950;
        font-weight: 600;
        .text {
          font-size: 33px;
          font-weight: bold;
          color: #000000;
        }
      }
      .lis3 {
        margin-top: 47px;
        width: 480px;
        height: 49px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #6a6a6a;
        line-height: 29px;
      }
    }
  }
}
.h8 {
  width: 100%;
  height: 1068px;
  background: url(../../assets/img/pagess/gdd112/h8.png) no-repeat center;
  .ss {
    width: 20px;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      top: -25px;
    }
  }
  .w {
    width: 1205px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 64px;
      color: #b5844a;
      font-size: 50px;
      font-weight: 650;
    }
    .li-2 {
      display: flex;
      align-items: center;
      margin-top: 85px;
      .r {
        width: 597px;
        height: 300px;
        background: url(../../assets/img/pagess/gdd112/h8-2.png) no-repeat
          center;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .lis1 {
          padding-left: 90px;
          padding-top: 40px;
          display: flex;
          align-items: center;
          margin-bottom: 34px;
          span {
            margin-left: 28px;
            font-size: 70px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #db4545;
            line-height: 40px;
          }
        }
        .lis2 {
          padding-left: 90px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          line-height: 40px;
        }
      }
    }
    .li-3 {
      display: flex;
      align-items: center;
      margin-top: 30px;
      .r {
        width: 597px;
        height: 300px;
        background: url(../../assets/img/pagess/gdd112/h8-4.png) no-repeat
          center;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .lis1 {
          padding-left: 124px;
          padding-top: 40px;
          display: flex;
          align-items: center;
          margin-bottom: 34px;
          span {
            margin-left: 28px;
            font-size: 70px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #db4545;
            line-height: 40px;
          }
        }
        .lis2 {
          padding-left: 124px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          line-height: 40px;
        }
      }
    }
  }
}
.h9 {
  width: 100%;
  height: 835px;
  background: url(../../assets/img/pagess/gdd112/h9.png) no-repeat center;
  .ss {
    width: 20px;
    margin: 0 auto;
    position: relative;
    img {
      position: absolute;
      top: -25px;
    }
  }
  .w {
    width: 1205px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 64px;
      color: #b5844a;
      font-size: 50px;
      font-weight: 650;
      margin-bottom: 98px;
    }
    .li-2 {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .lis1,
      .lis2,
      .lis3 {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 301px;
        height: 99px;
        font-size: 43px;
        font-weight: bold;
        color: #000000;
        span {
          color: #db4646;
        }
        .liss1 {
          margin-bottom: 28px;
        }
      }
    }
  }
}
.h10 {
  width: 100%;
  height: 917px;
  background-color: #f4f5f8;
  .w {
    width: 1202px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 69px;
      margin-bottom: 55px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pagess/gdd113.vue